import StarIcon from "../../../../svg/StarIcon";

export const StarRating = ({ value, onChange }) => {
    const totalStars = 5;
    return (
        <div className="d-flex align-items-center flex-wrap gap-1">
            {[...Array(totalStars)].map((_, index) => (
                <div
                    key={index}
                    onClick={onChange ? () => onChange(index + 1) : undefined}
                    style={{ cursor: onChange ? 'pointer' : 'default' }}
                >
                    <StarIcon filled={value > index} width="26" height="26" />
                </div>
            ))}
            {/* <span className="ms-2 small text-muted">
                {proficiencyLabels[value] || 'Not selected'}
            </span> */}
        </div>
    );
};
